module.exports = __webpack_public_path__ + "media/恭喜你们游戏结束了.165a10cc.mp3";